import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function instagramFeedAnimation() {
  
  if ( document.querySelectorAll(".js-instagram-feed").length ) {
    if (window.matchMedia('(min-width: 768px)').matches) {

      const instagramFeed = $('.js-instagram-slide');
      
      const instagramAnimation = gsap.timeline({
        ease: 'power2.out',
        scrollTrigger: {
          trigger: ".js-instagram-feed", 
          pin: false,
          //pinSpacing: true,
          scrub: 0.1,
          start: "top 90%",
          end: "400% 90%",
          toggleActions: "play pause play reset",
          //markers: true,
        }
      });
    
    
      instagramAnimation.fromTo( instagramFeed, { x: "80px" }, { x: "-60px" } );

    }
  }

  
}



export default instagramFeedAnimation;
